import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import { Navigation } from "./Navigation.js";
const NavigationContainer = (props) => {
  const { getLabel } = useIntl();
  const labels = React.useMemo(
    () => ({
      goBack: getLabel("cart.actions.goBack"),
      goToCheckout: getLabel("cart.actions.goToCheckout")
    }),
    [getLabel]
  );
  return /* @__PURE__ */ React.createElement(Navigation, { ...props, labels });
};
export {
  NavigationContainer
};
//# sourceMappingURL=NavigationContainer.js.map
